import { Severity } from '../../../../common/enums/Severity';
import { ReferenceLink } from '../../../../common/models/ReferenceLink';

export class Issue {
  constructor(
    private readonly issueNumber: number,
    private readonly title: string,
    private readonly severity: Severity,
    private readonly explanation: string | null,
    private readonly consequences: string | null,
    private readonly access: string | null,
    private readonly expertise: string | null,
    private readonly resources: string | null,
    private readonly kbLinks: ReferenceLink[]
  ) {}

  getNumber() {
    return this.issueNumber;
  }

  getTitle() {
    return this.title;
  }

  getSeverity() {
    return this.severity;
  }

  getExplanation() {
    return this.explanation;
  }

  getConsequences() {
    return this.consequences;
  }

  getAccess() {
    return this.access;
  }

  getExpertise() {
    return this.expertise;
  }

  getResources() {
    return this.resources;
  }

  getKbLinks() {
    return this.kbLinks;
  }
}
